"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

Vue.component("form-question", require("./Question.vue").default);

exports.default = {
  props: ["heading", "unique", "test", "old", "autosavedResults"],

  data: function data() {
    return {
      values: this.setValues()
    };
  },


  methods: {
    updateValue: function updateValue(id, value) {
      var question = _(this.values).filter(function (q) {
        return q.id == id;
      }).first();
      question.value = value;
    },
    getQuestionValue: function getQuestionValue(question) {
      return _(this.values).filter(function (q) {
        return q.id == question.unique;
      }).first().value;
    },
    setValues: function setValues() {
      var _this = this;

      return _(this.heading.questions).map(function (question) {
        return {
          id: question.unique,
          value: _this.getOldOrTestValue(question)
        };
      }).value();
    },
    getOldOrTestValue: function getOldOrTestValue(question) {
      try {
        return eval("this.old." + this.unique.join(".") + ".questions." + question.unique);
      } catch (error) {}

      var answer = null;

      // Search answers in saved test results.
      if (this.test) {
        try {
          answer = eval("this.test." + this.unique.join(".") + ".questions." + question.unique);
        } catch (err) {}
      }

      // Search answers in autosaved test results.
      if (!_.isEmpty(this.autosavedResults)) {
        try {
          answer = eval("this.autosavedResults." + this.unique.join(".") + ".questions." + question.unique);
        } catch (err) {}
      }

      return answer;
    },
    shouldDisplay: function shouldDisplay(question) {
      if (question.dependsonfield === undefined || question.dependsonfield === null) {
        return true;
      }

      var questionValue = _(this.values).filter(function (q) {
        return q.id == question.dependsonfield;
      }).first();

      if (question.dependsonvalue == questionValue.value) {
        return true;
      }

      this.updateValue(question.unique, null);

      return false;
    },
    generateUnique: function generateUnique(unique, type) {
      return _.concat(this.unique, [type, unique]);
    }
  }
};


//////////////////
// WEBPACK FOOTER
// ./~/babel-loader/lib?cacheDirectory!./~/vue-loader/lib/selector.js?type=script&index=0!./resources/assets/js/components/forms/Heading.vue
// module id = YR23
// module chunks = 0 1